import { render, staticRenderFns } from "./payment-order-add.vue?vue&type=template&id=55b74b00&scoped=true&"
import script from "./payment-order-add.vue?vue&type=script&lang=ts&"
export * from "./payment-order-add.vue?vue&type=script&lang=ts&"
import style0 from "./payment-order-add.vue?vue&type=style&index=0&id=55b74b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b74b00",
  null
  
)

export default component.exports